import {useGrubhubTokenInfo} from '@/lib/food-grubhub/store'

import useGrubhubGetAuth from './useGrubhubGetAuth'

export default function useGrubhubValidToken() {
  const [token] = useGrubhubTokenInfo()
  const {data: authResponse, isLoading} = useGrubhubGetAuth()

  const buffer = 60 * 1000 * 5
  const now = Date.now()

  const tokenStillValid =
    token.token && token.token_expire_time && now + buffer < token.token_expire_time

  let validToken = ''

  if (tokenStillValid) {
    validToken = token.token
  } else if (!isLoading && authResponse?.session_handle.access_token) {
    validToken = authResponse.session_handle.access_token
  }

  return validToken
}
